import React from 'react';
import { Editor } from '@tiptap/react';

const Toolbar: React.FC<{ editor: Editor }> = ({ editor }) => {
	if (!editor) return null;

	return (
		<div className="text-editor-toolbar">
			<button
				type="button"
				onClick={() => editor.chain().focus().toggleBold().run()}
				className={editor.isActive('bold') ? 'is-active' : ''}
				title="Bold"
			>
				B
			</button>
			<button
				type="button"
				onClick={() => editor.chain().focus().toggleItalic().run()}
				className={editor.isActive('italic') ? 'is-active' : ''}
				title="Italic"
			>
				I
			</button>
			<button
				type="button"
				onClick={() => editor.chain().focus().toggleUnderline().run()}
				className={editor.isActive('underline') ? 'is-active' : ''}
				title="Underline"
			>
				U
			</button>
			<input
				type="color"
				onChange={(e) => {
					editor.chain().focus().setColor(e.target.value).run();
				}}
				title="Text Color"
			/>
		</div>
	);
};

export default Toolbar;
